
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Folder, BarChart, Tag } from "lucide-react";
import CategoryList from "./CategoryList";
import CategoryStats from "./CategoryStats";
import CategoryKeywords from "./CategoryKeywords";
import { Category } from "./types";

interface CategoryTabsProps {
  categories: Category[];
  filteredCategories: Category[];
  isLoading: boolean;
  searchQuery: string;
  handleEditCategory: (category: Category) => void;
  handleArchiveCategory: (categoryId: string) => void;
}

const CategoryTabs = ({
  categories,
  filteredCategories,
  isLoading,
  searchQuery,
  handleEditCategory,
  handleArchiveCategory
}: CategoryTabsProps) => {
  return (
    <Tabs defaultValue="list">
      <TabsList className="mb-4">
        <TabsTrigger value="list" className="flex items-center gap-2">
          <Folder className="h-4 w-4" />
          <span>List View</span>
        </TabsTrigger>
        <TabsTrigger value="stats" className="flex items-center gap-2">
          <BarChart className="h-4 w-4" />
          <span>Statistics</span>
        </TabsTrigger>
        <TabsTrigger value="tags" className="flex items-center gap-2">
          <Tag className="h-4 w-4" />
          <span>Keywords</span>
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="list">
        <CategoryList 
          categories={filteredCategories}
          isLoading={isLoading}
          searchQuery={searchQuery}
          handleEditCategory={handleEditCategory}
          handleArchiveCategory={handleArchiveCategory}
        />
      </TabsContent>
      
      <TabsContent value="stats">
        <CategoryStats 
          categories={filteredCategories}
          isLoading={isLoading}
          handleEditCategory={handleEditCategory}
        />
      </TabsContent>
      
      <TabsContent value="tags">
        <CategoryKeywords 
          categories={filteredCategories}
          isLoading={isLoading}
        />
      </TabsContent>
    </Tabs>
  );
};

export default CategoryTabs;
